import {Brick, ErrorFlow, registerBrick} from 'olympe';

export default class OGBodyStoredQuery extends Brick {

    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {string} name
     * @param {string} bindings
     * @param {function()} forwardEvent
     * @param {function(string)} setBody
     * @param {function(*)} setErrorFlow
     */
    update($, [name, bindings], [forwardEvent, setBody, setErrorFlow]) {
        try {
            setBody({
                storedQuery: {
                    ...bindings,
                    name: name,
                },
            });
            forwardEvent();
        } catch (e) {
            setErrorFlow(ErrorFlow.create(`OGBodyStoredQuery: cannot create body: ${e}`, 1));
        }
    }
}

registerBrick('019909834ddefe0a4110', OGBodyStoredQuery);
